import { render, staticRenderFns } from "./AddEditMaterial.vue?vue&type=template&id=8e2f5aee&scoped=true"
import script from "./AddEditMaterial.vue?vue&type=script&lang=js"
export * from "./AddEditMaterial.vue?vue&type=script&lang=js"
import style0 from "./AddEditMaterial.vue?vue&type=style&index=0&id=8e2f5aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2f5aee",
  null
  
)

export default component.exports